import { reloadCopyright } from "./copyright";
import Swiper from "swiper";
import { Pagination, Navigation } from 'swiper/modules';

export function activateSlider() {
  function easeInOutQuad(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }

  function animateHeight(element, startHeight, endHeight, duration) {
    let startTime = null;

    function animate(time) {
      if (!startTime) startTime = time;  // Capture the initial time
      let timeElapsed = time - startTime;
      let progress = Math.min(timeElapsed / duration, 1); // Ensure progress doesn't go over 1

      // Apply easing to the progress
      let easedProgress = easeInOutQuad(progress);

      // Calculate the current height based on the eased progress
      let currentHeight = startHeight + (endHeight - startHeight) * easedProgress;

      element.style.height = currentHeight + 'px';  // Set the new height

      // Continue the animation until the target height is reached
      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        element.style.height = endHeight + 'px'; // Ensure it ends exactly at the target height
      }
    }

    requestAnimationFrame(animate);
  }

  function updateWrapperHeight(swiperInstance, wrapperSelector, activeIndex) {
    const activeSlide = swiperInstance.slides[activeIndex];
    if (activeSlide) {
      const slideInner = activeSlide.querySelector('.slide-inner');
      if (slideInner) {
        const wrapper = document.querySelector(wrapperSelector);
        if (wrapper) {
          // Verzögerung einbauen, damit Swiper alle Layout-Änderungen abgeschlossen hat
          setTimeout(() => {
            const targetHeight = slideInner.offsetHeight;
            const currentHeight = wrapper.offsetHeight;
            if (targetHeight !== currentHeight) {
              animateHeight(wrapper, currentHeight, targetHeight, 333); // Smooth animation over 600ms
            } else {
              wrapper.style.height = `${targetHeight}px`; // If no change, set immediately
            }
          }, 100); // Verzögerung von 100ms
        }
      }
    }
  }

  const contentSwiper = new Swiper(".ce-content-slider .swiper-container", {
    loop: true,
    autoHeight: true,
    slidesPerView: 1,
    spaceBetween: 30,
    modules: [Navigation, Pagination],
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
  });

  contentSwiper.on("slideChangeTransitionStart", () => {
    updateWrapperHeight(contentSwiper, ".ce-content-slider .swiper-wrapper", contentSwiper.activeIndex);
  });

  contentSwiper.on("slideChange", () => {
    reloadCopyright();
  });

  window.addEventListener("resize", () => {
    updateWrapperHeight(contentSwiper, ".ce-content-slider .swiper-wrapper", contentSwiper.activeIndex);
  });

  // Initial height adjustment
  updateWrapperHeight(contentSwiper, ".ce-content-slider .swiper-wrapper", contentSwiper.activeIndex);
}


document.addEventListener('DOMContentLoaded', function () {
    
  const factSliderElement = document.querySelector('.ce-factslider');

  if (!factSliderElement) {
    // Wenn .ce-factslider nicht existiert, wird der Code nicht weiter ausgeführt
    return;
  }  
    
  const factSwiper = new Swiper(".ce-factslider .swiper-container", {
    loop: true,
    autoHeight: false,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-header .slide-count .facts-pagination", // Prüfe, ob dieses Element korrekt vorhanden ist
      type: 'fraction',
      clickable: true,
    },
    keyboard: {
      enabled: true,
    },
    a11y: {
      prevSlideMessage: "Vorheriger Fakt",
      nextSlideMessage: "Nächster Fakt",
      firstSlideMessage: "Das ist der erste Fakt",
      lastSlideMessage: "Das ist der letzte Fakt",
    },
    modules: [Pagination, Navigation], // Achte darauf, dass Pagination auch hier als Modul geladen wird
  });

  // Initialisierung der Pagination manuell, falls notwendig
  factSwiper.on('init', function () {
    if (factSwiper.pagination) {
      factSwiper.pagination.update(); // Dies sollte nach der Initialisierung funktionieren
    }
  });

  factSwiper.init();  // Manuelle Initialisierung sicherstellen

  // Event-Listener für Buttons
  document.querySelector('.ce-factslider .swiper-button-next').addEventListener('click', function () {
    factSwiper.slideNext();
  });

  document.querySelector('.ce-factslider .swiper-button-prev').addEventListener('click', function () {
    factSwiper.slidePrev();
  });
  
});
